import { ChangeEvent, FC, ReactElement, ReactNode } from "react";

import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";
import Typography from "@mui/material/Typography";

import GridContainer from "components/Grid/GridContainer";
import Loader from "components/Loader";
import NoItems from "components/NoItems";

interface ListItemsProps {
  isEmbedded?: boolean;
  isLoading?: boolean;
  loadMore?: boolean;
  items: any[];
  noItemsComponent?: ReactElement;
  renderItem: (value: any, index: number) => ReactNode;
  pagination?: {
    totalPages?: number;
    page?: number;
  };
  handleChangePage?: (e: ChangeEvent<unknown>, page: number) => void;
  onLoadMore?: () => void;
  showPlaceholder?: boolean;
  areFilters?: boolean;
}

const ListItems: FC<ListItemsProps> = ({
  isEmbedded = false,
  isLoading = false,
  items,
  noItemsComponent = null,
  renderItem,
  pagination = null,
  handleChangePage = null,
  showPlaceholder = true,
  areFilters = false,
}) => {
  if (isLoading) {
    return (
      <Box width="100%" mt={8} minHeight="45vh">
        <Loader />
      </Box>
    );
  }

  if (!isLoading && items.length === 0 && showPlaceholder) {
    return (
      noItemsComponent || (
        <NoItems>
          <div>
            <Typography component="h2" variant="h2" gutterBottom>
              Sorry, there are no items
            </Typography>
            {areFilters && (
              <Typography>Change your search criteria.</Typography>
            )}
          </div>
        </NoItems>
      )
    );
  }

  return (
    <>
      <GridContainer display="flex" alignItems="stretch">
        {items?.map(renderItem)}
      </GridContainer>
      {!isLoading && pagination?.totalPages && pagination.totalPages > 1 && (
        <Box
          display="flex"
          justifyContent="center"
          width="100%"
          my={!isEmbedded ? 4 : 0}
        >
          <Pagination
            page={pagination.page}
            count={pagination.totalPages}
            onChange={handleChangePage || undefined}
            siblingCount={0}
            color="secondary"
          />
        </Box>
      )}
    </>
  );
};

export default ListItems;
